import { render } from "./EmergencyForm.vue?vue&type=template&id=52c17afc&scoped=true&ts=true"
import script from "./EmergencyForm.ts?vue&type=script&lang=ts"
export * from "./EmergencyForm.ts?vue&type=script&lang=ts"

import "./EmergencyForm.scss?vue&type=style&index=0&id=52c17afc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c17afc"]])

export default __exports__